// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"cSMpV","title":"YzN9C","text":"eALu2","media":"QET0V","mediaWrapper":"s8EuB","callout":"JEuKv","only-text":"jyN-o","mediaWrapperHalf":"ZAba1"};